/**
 * EastSupplier — Offers section animated icons (Canvas)
 */
(function () {
  'use strict';

  var ORANGE = '#ff6128';
  var BLUE = '#2b6cb0';
  var BLUE_LIGHT = '#5a9fd4';
  var INK = '#3a2a2f';

  function initOfferCanvas(canvas) {
    if (canvas.dataset.esOfferCanvasInit === '1') return;
    canvas.dataset.esOfferCanvasInit = '1';

    var type = canvas.getAttribute('data-offer-icon') || 'sourcing';
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var size = 150;
    var cx = 75;
    var cy = 75;
    var layState = { lastSize: 0 };
    var time = 0;
    var rafId = null;
    var running = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function resize() {
      var L = window.EastSupplierCanvasLayout;
      var logical = 150;

      if (L && L.measureSquare) {
        var m = L.measureSquare(canvas, canvas.parentElement, {
          size: 150,
          minSize: 100,
          state: layState,
        });
        logical = m.w;
        dpr = m.dpr;
        L.applyBitmap(canvas, ctx, logical, logical, dpr);
      } else {
        logical = 150;
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.floor(logical * dpr);
        canvas.height = Math.floor(logical * dpr);
        if (canvas.style) {
          canvas.style.width = '';
          canvas.style.height = '';
        }
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }

      size = logical;
      cx = size / 2;
      cy = size / 2;
    }

    function clear() {
      ctx.clearRect(0, 0, size, size);
    }

    function drawPerson(x, y, scale, color) {
      ctx.save();
      ctx.translate(x, y);
      ctx.scale(scale, scale);
      ctx.strokeStyle = color;
      ctx.fillStyle = color;
      ctx.lineWidth = 2.2;
      ctx.beginPath();
      ctx.arc(0, -8, 7, 0, Math.PI * 2);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(0, -1);
      ctx.lineTo(0, 14);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(-10, 6);
      ctx.lineTo(10, 6);
      ctx.stroke();
      ctx.restore();
    }

    function drawSourcing(t) {
      clear();
      var pulse = reducedMotion ? 1 : 0.85 + 0.15 * Math.sin(t * 2.2);
      var nodes = 5;
      var radius = size * 0.32;

      for (var i = 0; i < nodes; i++) {
        var angle = (i / nodes) * Math.PI * 2 - Math.PI / 2 + (reducedMotion ? 0 : t * 0.15);
        var nx = cx + Math.cos(angle) * radius;
        var ny = cy + Math.sin(angle) * radius;
        var np = reducedMotion ? 1 : 0.7 + 0.3 * Math.sin(t * 3 + i);

        ctx.strokeStyle = INK;
        ctx.lineWidth = 1.5;
        ctx.beginPath();
        ctx.moveTo(cx, cy);
        ctx.lineTo(nx, ny);
        ctx.stroke();

        ctx.beginPath();
        ctx.fillStyle = BLUE;
        ctx.arc(nx, ny, 7 * np, 0, Math.PI * 2);
        ctx.fill();
        ctx.strokeStyle = BLUE_LIGHT;
        ctx.lineWidth = 1;
        ctx.stroke();
      }

      ctx.beginPath();
      ctx.fillStyle = 'rgba(255, 97, 40, 0.15)';
      ctx.arc(cx, cy, 18 * pulse, 0, Math.PI * 2);
      ctx.fill();
      drawPerson(cx, cy, 1.1, ORANGE);
    }

    function drawNegotiation(t) {
      clear();
      var rot = reducedMotion ? 0 : t * 1.8;
      var arm = size * 0.19;

      drawPerson(cx, cy - size * 0.15, 0.95, ORANGE);
      drawPerson(cx, cy + size * 0.15, 0.95, ORANGE);

      ctx.save();
      ctx.translate(cx, cy);
      ctx.rotate(rot);
      ctx.strokeStyle = BLUE;
      ctx.fillStyle = BLUE;
      ctx.lineWidth = 2.5;
      ctx.lineCap = 'round';

      ctx.beginPath();
      ctx.arc(0, 0, arm, -Math.PI * 0.85, -Math.PI * 0.15);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(arm * 0.78, -arm * 0.28);
      ctx.lineTo(arm * 1.07, -arm * 0.14);
      ctx.lineTo(arm * 0.86, arm * 0.07);
      ctx.fill();

      ctx.beginPath();
      ctx.arc(0, 0, arm, Math.PI * 0.85, Math.PI * 0.15);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(-arm * 0.78, arm * 0.28);
      ctx.lineTo(-arm * 1.07, arm * 0.14);
      ctx.lineTo(-arm * 0.86, -arm * 0.07);
      ctx.fill();
      ctx.restore();
    }

    function drawSampling(t) {
      clear();
      var bob = reducedMotion ? 0 : Math.sin(t * 2) * 3;
      var docW = size * 0.32;
      var docH = size * 0.38;

      ctx.save();
      ctx.translate(cx - size * 0.05, cy + size * 0.03);
      ctx.fillStyle = BLUE;
      ctx.strokeStyle = BLUE_LIGHT;
      ctx.lineWidth = 1.5;
      ctx.beginPath();
      ctx.moveTo(-docW, -docH);
      ctx.lineTo(docW * 0.67, -docH);
      ctx.quadraticCurveTo(docW * 0.83, -docH, docW * 0.83, -docH * 0.87);
      ctx.lineTo(docW * 0.83, docH);
      ctx.quadraticCurveTo(docW * 0.83, docH * 1.08, docW * 0.67, docH * 1.08);
      ctx.lineTo(-docW, docH * 1.08);
      ctx.quadraticCurveTo(-docW * 1.17, docH * 1.08, -docW * 1.17, docH);
      ctx.lineTo(-docW * 1.17, -docH * 0.87);
      ctx.quadraticCurveTo(-docW * 1.17, -docH, -docW, -docH);
      ctx.closePath();
      ctx.fill();
      ctx.strokeStyle = 'rgba(255,255,255,0.5)';
      ctx.lineWidth = 2;
      for (var i = 0; i < 4; i++) {
        ctx.beginPath();
        ctx.moveTo(-docW * 0.83, -docH * 0.73 + i * (docH * 0.4));
        ctx.lineTo(docW * 0.5, -docH * 0.73 + i * (docH * 0.4));
        ctx.stroke();
      }
      ctx.restore();

      ctx.save();
      ctx.translate(cx + size * 0.15 + bob * 0.3, cy - size * 0.12 + bob);
      ctx.strokeStyle = ORANGE;
      ctx.fillStyle = 'rgba(255, 97, 40, 0.12)';
      ctx.lineWidth = 2.5;
      var magR = size * 0.11;
      ctx.beginPath();
      ctx.arc(0, 0, magR, 0, Math.PI * 2);
      ctx.fill();
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(magR * 0.62, magR * 0.62);
      ctx.lineTo(magR * 1.38, magR * 1.38);
      ctx.strokeStyle = ORANGE;
      ctx.lineWidth = 3;
      ctx.lineCap = 'round';
      ctx.stroke();
      ctx.restore();
    }

    function drawLogistics(t) {
      clear();

      var s = size;
      var travel = reducedMotion ? 0 : ((t * 0.5) % 1);

      /* ── ground line ── */
      var groundY = s * 0.66;
      ctx.strokeStyle = 'rgba(43,108,176,0.25)';
      ctx.lineWidth = 1.5;
      ctx.beginPath();
      ctx.moveTo(s * 0.06, groundY);
      ctx.lineTo(s * 0.94, groundY);
      ctx.stroke();

      /* ── animated dashed road markings ── */
      ctx.save();
      ctx.strokeStyle = 'rgba(90,159,212,0.45)';
      ctx.lineWidth = 1.8;
      ctx.setLineDash([s * 0.07, s * 0.055]);
      ctx.lineDashOffset = -travel * s * 0.125;
      ctx.beginPath();
      ctx.moveTo(s * 0.06, groundY - s * 0.015);
      ctx.lineTo(s * 0.94, groundY - s * 0.015);
      ctx.stroke();
      ctx.setLineDash([]);
      ctx.restore();

      /* ── truck body offset by travel ── */
      var offsetX = reducedMotion ? 0 : (travel * s * 0.28 - s * 0.04);
      ctx.save();
      ctx.translate(offsetX, 0);

      var bx  = s * 0.10;   /* cargo box left */
      var by  = groundY - s * 0.32;
      var bw  = s * 0.42;
      var bh  = s * 0.32;
      var cab = s * 0.185;  /* cab width */

      /* cargo box */
      ctx.fillStyle = BLUE;
      ctx.strokeStyle = BLUE_LIGHT;
      ctx.lineWidth = 2;
      var r1 = s * 0.025;
      ctx.beginPath();
      ctx.moveTo(bx + r1, by);
      ctx.lineTo(bx + bw - r1, by);
      ctx.quadraticCurveTo(bx + bw, by, bx + bw, by + r1);
      ctx.lineTo(bx + bw, by + bh - r1);
      ctx.quadraticCurveTo(bx + bw, by + bh, bx + bw - r1, by + bh);
      ctx.lineTo(bx + r1, by + bh);
      ctx.quadraticCurveTo(bx, by + bh, bx, by + bh - r1);
      ctx.lineTo(bx, by + r1);
      ctx.quadraticCurveTo(bx, by, bx + r1, by);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();

      /* cargo stripe */
      ctx.strokeStyle = 'rgba(255,255,255,0.18)';
      ctx.lineWidth = 1.2;
      ctx.beginPath();
      ctx.moveTo(bx + bw * 0.32, by + bh * 0.12);
      ctx.lineTo(bx + bw * 0.32, by + bh * 0.88);
      ctx.stroke();

      /* "ES" text on cargo side */
      ctx.fillStyle = 'rgba(255,255,255,0.72)';
      ctx.font = 'bold ' + Math.round(s * 0.11) + 'px sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('ES', bx + bw * 0.52, by + bh * 0.5);

      /* cab */
      var cabX = bx + bw;
      var cabY = by + bh * 0.22;
      var cabH = bh * 0.78;
      ctx.fillStyle = ORANGE;
      ctx.strokeStyle = '#d44c10';
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(cabX, by + bh);          /* cab bottom-left = box bottom-right */
      ctx.lineTo(cabX, cabY);
      ctx.quadraticCurveTo(cabX + cab * 0.15, by, cabX + cab * 0.55, by);
      ctx.quadraticCurveTo(cabX + cab, by, cabX + cab, cabY + bh * 0.14);
      ctx.lineTo(cabX + cab, by + bh);
      ctx.closePath();
      ctx.fill();
      ctx.stroke();

      /* windscreen */
      ctx.fillStyle = 'rgba(180,220,255,0.75)';
      ctx.beginPath();
      ctx.moveTo(cabX + cab * 0.1, cabY + bh * 0.06);
      ctx.lineTo(cabX + cab * 0.1, cabY + bh * 0.42);
      ctx.lineTo(cabX + cab * 0.86, cabY + bh * 0.42);
      ctx.lineTo(cabX + cab * 0.86, cabY + bh * 0.14);
      ctx.quadraticCurveTo(cabX + cab * 0.86, cabY + bh * 0.06, cabX + cab * 0.72, cabY + bh * 0.02);
      ctx.quadraticCurveTo(cabX + cab * 0.35, by - bh * 0.04, cabX + cab * 0.1, cabY + bh * 0.06);
      ctx.closePath();
      ctx.fill();

      /* headlight */
      var hlX = cabX + cab * 0.88;
      var hlY = cabY + bh * 0.52;
      var hlR = s * 0.035;
      var glowR = reducedMotion ? hlR * 1.8 : hlR * (1.5 + 0.5 * Math.sin(t * 4));
      ctx.beginPath();
      ctx.arc(hlX, hlY, glowR, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255,240,100,0.3)';
      ctx.fill();
      ctx.beginPath();
      ctx.arc(hlX, hlY, hlR, 0, Math.PI * 2);
      ctx.fillStyle = '#ffe060';
      ctx.fill();

      /* wheels */
      function drawWheel(wx, wy) {
        var wr = s * 0.068;
        var hubR = wr * 0.38;
        var spoke = reducedMotion ? 0 : -t * 3.5;
        ctx.beginPath();
        ctx.arc(wx, wy, wr, 0, Math.PI * 2);
        ctx.fillStyle = '#1a3a5c';
        ctx.fill();
        ctx.strokeStyle = BLUE_LIGHT;
        ctx.lineWidth = 1.8;
        ctx.stroke();
        /* tyre tread ring */
        ctx.beginPath();
        ctx.arc(wx, wy, wr * 0.82, 0, Math.PI * 2);
        ctx.strokeStyle = 'rgba(90,159,212,0.5)';
        ctx.lineWidth = 1.2;
        ctx.stroke();
        /* hub */
        ctx.beginPath();
        ctx.arc(wx, wy, hubR, 0, Math.PI * 2);
        ctx.fillStyle = BLUE_LIGHT;
        ctx.fill();
        /* spokes */
        for (var si = 0; si < 4; si++) {
          var sa = spoke + (si / 4) * Math.PI * 2;
          ctx.beginPath();
          ctx.moveTo(wx + Math.cos(sa) * hubR, wy + Math.sin(sa) * hubR);
          ctx.lineTo(wx + Math.cos(sa) * wr * 0.76, wy + Math.sin(sa) * wr * 0.76);
          ctx.strokeStyle = '#1a3a5c';
          ctx.lineWidth = 1.5;
          ctx.stroke();
        }
      }

      var wheelY = groundY + s * 0.052;
      drawWheel(bx + bw * 0.23, wheelY);         /* rear wheel */
      drawWheel(cabX + cab * 0.66, wheelY);       /* front wheel */

      ctx.restore();

      /* ── moving dots: packages in transit ── */
      var dotCount = 3;
      for (var di = 0; di < dotCount; di++) {
        var phase = ((travel + di / dotCount) % 1);
        var dx = s * 0.06 + phase * s * 0.88;
        var dy = groundY - s * 0.48 - s * 0.06 * Math.sin(phase * Math.PI);
        var alpha = 1 - Math.abs(phase - 0.5) * 1.6;
        if (alpha <= 0) continue;
        ctx.globalAlpha = reducedMotion ? 0.7 : Math.max(0, alpha);
        ctx.fillStyle = ORANGE;
        var pw = s * 0.076, pr = s * 0.016;
        var px = dx - pw / 2, py = dy - pw / 2;
        ctx.beginPath();
        ctx.moveTo(px + pr, py);
        ctx.lineTo(px + pw - pr, py);
        ctx.quadraticCurveTo(px + pw, py, px + pw, py + pr);
        ctx.lineTo(px + pw, py + pw - pr);
        ctx.quadraticCurveTo(px + pw, py + pw, px + pw - pr, py + pw);
        ctx.lineTo(px + pr, py + pw);
        ctx.quadraticCurveTo(px, py + pw, px, py + pw - pr);
        ctx.lineTo(px, py + pr);
        ctx.quadraticCurveTo(px, py, px + pr, py);
        ctx.closePath();
        ctx.fill();
        /* small arrow */
        ctx.strokeStyle = '#fff';
        ctx.lineWidth = 1.5;
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.moveTo(dx - s * 0.016, dy);
        ctx.lineTo(dx + s * 0.016, dy);
        ctx.moveTo(dx + s * 0.006, dy - s * 0.012);
        ctx.lineTo(dx + s * 0.016, dy);
        ctx.lineTo(dx + s * 0.006, dy + s * 0.012);
        ctx.stroke();
        ctx.globalAlpha = 1;
      }
    }

    var drawers = {
      sourcing: drawSourcing,
      negotiation: drawNegotiation,
      sampling: drawSampling,
      logistics: drawLogistics,
    };

    function frame(ts) {
      if (!running) return;

      var expected = Math.max(1, Math.floor(size * dpr));
      if (canvas.width < expected * 0.5 || canvas.height < expected * 0.5) {
        resize();
      }

      if (!reducedMotion) time = ts * 0.001;
      var draw = drawers[type] || drawSourcing;
      draw(time);
      rafId = requestAnimationFrame(frame);
    }

    function start() {
      if (running) return;
      resize();
      running = true;
      rafId = requestAnimationFrame(frame);
    }

    function stop() {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
    }

    resize();
    window.addEventListener('resize', resize);

    if (typeof ResizeObserver !== 'undefined' && canvas.parentElement) {
      new ResizeObserver(function () {
        resize();
      }).observe(canvas.parentElement);
    }

    requestAnimationFrame(function () {
      resize();
      start();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              resize();
              start();
            } else stop();
          });
        },
        { threshold: 0.1 }
      ).observe(canvas);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else {
        resize();
        var br = canvas.getBoundingClientRect();
        if (br.bottom > 0 && br.top < window.innerHeight) start();
      }
    });

    window.addEventListener('pageshow', function () {
      resize();
      start();
    });
  }

  function boot() {
    document.querySelectorAll('[data-offer-canvas]').forEach(initOfferCanvas);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
